/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_MissedInputs */

const bn_game_missed = /** @type {(inputs: Game_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মিস`)
};

const de_game_missed = /** @type {(inputs: Game_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verpasst`)
};

const el_game_missed = /** @type {(inputs: Game_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Χάθηκε`)
};

const en_game_missed = /** @type {(inputs: Game_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missed`)
};

const es_game_missed = /** @type {(inputs: Game_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omitido`)
};

const fr_game_missed = /** @type {(inputs: Game_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raté`)
};

const hi_game_missed = /** @type {(inputs: Game_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चुक होना`)
};

const hu_game_missed = /** @type {(inputs: Game_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elmaradt`)
};

const id_game_missed = /** @type {(inputs: Game_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dirindukan`)
};

const it_game_missed = /** @type {(inputs: Game_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mancato`)
};

const ja_game_missed = /** @type {(inputs: Game_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`逃した`)
};

const ko_game_missed = /** @type {(inputs: Game_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`놓친`)
};

const nl_game_missed = /** @type {(inputs: Game_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gemist`)
};

const pl_game_missed = /** @type {(inputs: Game_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pominięty`)
};

const pt_game_missed = /** @type {(inputs: Game_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perdido`)
};

const ru_game_missed = /** @type {(inputs: Game_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пропущенный`)
};

const sv_game_missed = /** @type {(inputs: Game_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saknad`)
};

const tr_game_missed = /** @type {(inputs: Game_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaçırıldı`)
};

const uk_game_missed = /** @type {(inputs: Game_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пропущений`)
};

const vi_game_missed = /** @type {(inputs: Game_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bỏ lỡ`)
};

const zh_game_missed = /** @type {(inputs: Game_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错过了`)
};

const zh_hant_game_missed = /** @type {(inputs: Game_MissedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`錯過了`)
};

/**
* | output |
* | --- |
* | "Missed" |
*
* @param {Game_MissedInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_missed = /** @type {((inputs?: Game_MissedInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_MissedInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_missed(inputs)
	if (locale === "de") return de_game_missed(inputs)
	if (locale === "el") return el_game_missed(inputs)
	if (locale === "en") return en_game_missed(inputs)
	if (locale === "es") return es_game_missed(inputs)
	if (locale === "fr") return fr_game_missed(inputs)
	if (locale === "hi") return hi_game_missed(inputs)
	if (locale === "hu") return hu_game_missed(inputs)
	if (locale === "id") return id_game_missed(inputs)
	if (locale === "it") return it_game_missed(inputs)
	if (locale === "ja") return ja_game_missed(inputs)
	if (locale === "ko") return ko_game_missed(inputs)
	if (locale === "nl") return nl_game_missed(inputs)
	if (locale === "pl") return pl_game_missed(inputs)
	if (locale === "pt") return pt_game_missed(inputs)
	if (locale === "ru") return ru_game_missed(inputs)
	if (locale === "sv") return sv_game_missed(inputs)
	if (locale === "tr") return tr_game_missed(inputs)
	if (locale === "uk") return uk_game_missed(inputs)
	if (locale === "vi") return vi_game_missed(inputs)
	if (locale === "zh") return zh_game_missed(inputs)
	return zh_hant_game_missed(inputs)
});